export const categories = [
  {
    id: 'gaoxiao',
    name: '搞笑',
    slug: 'gaoxiao',
    icon: 'ri-emotion-laugh-line',
    description: '轻松一刻，笑料不断',
    videoCount: 1280,
    color: 'bg-amber-100 text-amber-700',
  },
  {
    id: 'meishi',
    name: '美食',
    slug: 'meishi',
    icon: 'ri-restaurant-line',
    description: '舌尖上的精彩世界',
    videoCount: 956,
    color: 'bg-orange-100 text-orange-700',
  },
  {
    id: 'yinyue',
    name: '音乐',
    slug: 'yinyue',
    icon: 'ri-music-line',
    description: '音符跳动，律动生活',
    videoCount: 2100,
    color: 'bg-rose-100 text-rose-700',
  },
  {
    id: 'youxi',
    name: '游戏',
    slug: 'youxi',
    icon: 'ri-gamepad-line',
    description: '游戏世界的无限可能',
    videoCount: 1870,
    color: 'bg-emerald-100 text-emerald-700',
  },
  {
    id: 'lvxing',
    name: '旅行',
    slug: 'lvxing',
    icon: 'ri-earth-line',
    description: '用镜头记录世界之美',
    videoCount: 745,
    color: 'bg-cyan-100 text-cyan-700',
  },
  {
    id: 'keji',
    name: '科技',
    slug: 'keji',
    icon: 'ri-smartphone-line',
    description: '前沿科技，触手可及',
    videoCount: 632,
    color: 'bg-slate-100 text-slate-700',
  },
  {
    id: 'tiyu',
    name: '体育',
    slug: 'tiyu',
    icon: 'ri-basketball-line',
    description: '热血赛场，激情无限',
    videoCount: 890,
    color: 'bg-red-100 text-red-700',
  },
  {
    id: 'shishang',
    name: '时尚',
    slug: 'shishang',
    icon: 'ri-shirt-line',
    description: '潮流穿搭，个性表达',
    videoCount: 567,
    color: 'bg-fuchsia-100 text-fuchsia-700',
  },
];

export const getCategoryBySlug = (slug: string) =>
  categories.find((c) => c.slug === slug);